/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, FontSizes, IStackStyles, IStackTokens, ITextStyles } from "@fluentui/react";

const theme = getTheme();

export const commentStackTokens: IStackTokens = { childrenGap: "1rem" };

export const commentContainerStackStyles: IStackStyles = {
  root: {
    padding: "1rem 0",
    justifyContent: "space-between",
  },
};

export const commentTextStackStyles: IStackStyles = {
  root: {
    border: `1px solid ${theme.palette.neutralTertiary}`,
    borderRadius: "0.5rem",
    width: "70%",
    padding: "1.5rem 1rem",
  },
};

export const createdTextStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.size16,
  },
};

export const createdDateTextStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.size16,
    fontWeight: 600,
  },
};

export const commentTextStyles: ITextStyles = {
  root: {
    marginBottom: "1rem",
    overflowWrap: "break-word",
    fontSize: FontSizes.size16,
  },
};
